import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { API } from "@/lib/api";

// Opens an authenticated SSE stream and reacts to WhatsApp events (tenant-scoped).
export function useRealtime(enabled = true) {
  const qc = useQueryClient();
  const ref = useRef(null);

  useEffect(() => {
    if (!enabled) return;
    const token = localStorage.getItem("cx_access_token");
    if (!token) return;
    const es = new EventSource(`${API}/whatsapp/stream?token=${encodeURIComponent(token)}`);
    ref.current = es;

    es.onmessage = (e) => {
      try {
        const evt = JSON.parse(e.data);
        const name = evt.event;
        if (name === "whatsapp.message.received") {
          toast.info("Nuovo messaggio WhatsApp ricevuto");
          qc.invalidateQueries({ queryKey: ["notifications"] });
        }
        if (name?.startsWith("whatsapp.message.")) {
          qc.invalidateQueries({ queryKey: ["wa-messages"] });
          qc.invalidateQueries({ queryKey: ["wa-conversations"] });
          qc.invalidateQueries({ queryKey: ["dashboard"] });
        }
        if (name?.startsWith("whatsapp.channel.")) {
          qc.invalidateQueries({ queryKey: ["wa-channels"] });
          qc.invalidateQueries({ queryKey: ["wa-accounts"] });
        }
        if (name?.startsWith("whatsapp.template.")) {
          qc.invalidateQueries({ queryKey: ["wa-templates"] });
        }
      } catch (_) {}
    };
    es.onerror = () => { /* browser auto-reconnects */ };

    return () => { es.close(); ref.current = null; };
  }, [enabled, qc]);
}
